import { TEnvironment } from './type'

export const environment: TEnvironment = {
  apiUrl: 'https://api.dev.luciapp.ca/',
  env: 'dev',
  production: false,
  sentry: {
    dsn: 'https://23967060b7040de39c8718f6912dc864@o4506656300662784.ingest.us.sentry.io/4511060513062912',
    release: '0.0.1',
    enabled: true,
  },
  oidc: {
    clientId: '4mlr6g6f8jgrkq6knu0hs502ks',
    authority: 'https://cognito-idp.ca-central-1.amazonaws.com/ca-central-1_U2MpMZYhp',
  },
}
